/** 数据规则组API */
import type { Api } from '@/typings/api';
import { post } from '../../request';
const prefix = '/sys/dataFilterGroup';
/**
 * 分页查询数据规则组
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Sys.DataFilterGroup> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询数据规则组列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Sys.DataFilterGroup> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个数据规则组
 *
 * @param id 数据规则组ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Sys.DataFilterGroup> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存数据规则组
 *
 * @param params 数据规则组信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新数据规则组信息
 *
 * @param params 数据规则组信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除数据规则组
 *
 * @param id 数据规则组ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除数据规则组
 *
 * @param ids 数据规则组ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete
};
